<template>
  <v-container fluid>
    <v-row class="child-flex">
      <v-card>
        <v-card-text>
          <v-card-title>
            Scheduled Reports
            <refresh-spinner
              v-model="isRefreshingData"
              @click="fetchData"
            ></refresh-spinner>
            <v-spacer></v-spacer>
            <v-text-field
              @keydown.native.escape="search = ''"
              label="Search"
              single-line
              clearable
              persistent-hint
              hint="Filter by name"
              v-model="search"
            >
            </v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{ name: 'new_datasource_mailer_path' }">
              <v-icon left>mdi-plus</v-icon>
              New Datasource Mailer
            </v-btn>
          </v-card-title>
        </v-card-text>

        <v-data-table
          :headers="tableColumns"
          :items="tableData"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:item.name="{ item }">
            <router-link
              :to="{ name: 'datasource_mailer_path', params: { id: item.id } }"
            >
              {{ item.name }}
            </router-link>
          </template>
          <template v-slot:item.email_type="{ item }">
            <v-chip :color="emailTypeColor(item.email_type)" small>
              {{ item.email_type | titleize }}
            </v-chip>
          </template>
          <template v-slot:item.is_split_tested="{ item }">
            <v-icon
              v-if="item.is_split_tested"
              :color="scheduleTypeColor(item.schedule_type)"
              >mdi-ab-testing</v-icon
            >
          </template>
          <template v-slot:item.next_scheduled_event="{ item }">
            {{ formatExecutionTime(item.next_scheduled_event) }}
          </template>
          <template v-slot:item.last_scheduled_event="{ item }">
            {{ item.last_scheduled_event| usDateTime }}
          </template>

          <template v-slot:item.actions="{ item }">
            <template v-for="(rowAction, index) in actions">
              <v-tooltip top :key="index">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    medium
                    class="mr-2"
                    @click="executeAction(rowAction.action, item)"
                    >{{ rowAction.icon }}</v-icon
                  >
                </template>
                <span>{{ rowAction.title }}</span>
              </v-tooltip>
            </template>
          </template>
        </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// import { mapState } from 'vuex'
import RefreshSpinner from '@/components/ui/RefreshSpinner'
import { useDatasourceMailerCrud } from './crudComposable'
import { DateTime } from 'luxon'

export default {
  setup () {
    const { fetchAll, datasourceMailers, destroy } = useDatasourceMailerCrud()
    return {
      fetchAll,
      datasourceMailers,
      destroy
    }
  },
  components: {
    RefreshSpinner
  },
  data () {
    return {
      search: '',

      propsToSearch: ['name'],
      tableColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Last Run', value: 'last_scheduled_event' },
        { text: 'Next Run', value: 'next_scheduled_event' },
        { text: 'Actions', value: 'actions' }
      ],
      actions: [
        { title: 'View', action: 'handleView', icon: 'mdi-binoculars' },
        { title: 'Edit', action: 'handleEdit', icon: 'mdi-pencil' },
        { title: 'Delete', action: 'handleDelete', icon: 'mdi-delete' }
      ],
      isRefreshingData: false
    }
  },
  computed: {
    tableData () {
      let result = this.datasourceMailers.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          if (row[key].toLowerCase().includes(this.search.toLowerCase())) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    }
  },
  methods: {
    fetchData () {
      this.isRefreshingData = true
      this.fetchAll()
        .then(response => {
          this.isRefreshingData = false
        })
        .catch(error => {
          this.isRefreshingData = false
          this.$flash({
            showClose: true,
            message: 'Error loading Datasource Mailers. ' + error.message,
            type: 'error'
          })
        })
    },
    formatExecutionTime (time, valueIfNull = 'Unscheduled/Complete') {
      if (time) {
        return DateTime.fromISO(time).toLocaleString(DateTime.DATETIME_SHORT)
      } else {
        return valueIfNull
      }
    },
    executeAction (action, item) {
      this[action](item)
    },
    handleEdit (item) {
      this.$router.push({ name: 'edit_datasource_mailer_path', params: { id: item.id } })
    },
    handleView (item) {
      this.$router.push({ name: 'datasource_mailer_path', params: { id: item.id } })
    },
    handleDelete (item) {
      const shouldDelete = confirm(`Are you sure you want to delete [${item.name}]?`)
      if (shouldDelete) {
        this.destroy(item.id)
          .then(() => {
            this.$flash({
              showClose: true,
              message: 'Datasource Mailer deleted.',
              type: 'mini',
              duration: 3000
            })
            this.fetchData()
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error deleting Datasource Mailer. ' + error.message,
              type: 'error'
            })
          })
      }
    }

  },
  mounted () {
    this.fetchData()
  }

}

</script>
